export default __webpack_public_path__ + "static/media/72.e0e3e548.png";